<!--begin::Head-->
<div class="kt-login__head">
	<!-- <span class="kt-login__signup-label">Don't have an account yet?</span>&nbsp;&nbsp;
	<a href="javascript:;" routerLink="/auth/register" class="kt-link kt-login__signup-link">{{ 'AUTH.GENERAL.SIGNUP_BUTTON' | translate }}</a> -->
</div>
<!--end::Head-->

<!--begin::Body-->
<div class="kt-login__body">
	<!--begin::Signin-->
	<div class="kt-login__form">
		<div class="kt-login__title">
			<h3>{{'AUTH.LOGIN.SIGNIN' | localize }}</h3>
		</div>

		<!-- <kt-auth-notice></kt-auth-notice> -->

		<!--begin::Form-->
		<form class="kt-form" [formGroup]="loginForm" autocomplete="off">
			<div class="form-group">
				<mat-form-field>
					<mat-label>{{ 'AUTH.INPUT.EMAIL' | localize }}</mat-label>
					<input matInput type="text" placeholder="{{ 'AUTH.INPUT.EMAIL' | localize }}" formControlName="username" autocomplete="off"/>
					<mat-error *ngIf="isControlHasError('username','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | localize }}</strong>
					</mat-error>
					<!-- <mat-error *ngIf="isControlHasError('username','email')">
						<strong>{{ 'AUTH.VALIDATION.INVALID_FIELD' | localize }}</strong>
					</mat-error> -->
					<mat-error *ngIf="isControlHasError('username','minlength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | localize }} 3</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('username','maxlength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | localize }} 320</strong>
					</mat-error>
				</mat-form-field>
			</div>
			<div class="form-group">
				<mat-form-field>
					<mat-label>{{ 'AUTH.INPUT.PASSWORD' | localize }}</mat-label>
					<input matInput type="password" placeholder="{{ 'AUTH.INPUT.PASSWORD' | localize }}" formControlName="password" autocomplete="off"/>
					<mat-error *ngIf="isControlHasError('password','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | localize }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('password','minlength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | localize }} 3</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('password','maxlength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | localize }} 100</strong>
					</mat-error>
				</mat-form-field>
			</div>
			<!--begin::Action-->
			<div class="kt-login__actions">
				<a href="javascript:;" routerLink="../forgot-password" class="kt-link kt-login__link-forgot">
					{{ 'AUTH.GENERAL.FORGOT_BUTTON' | localize }}
				</a>
				<button (click)="submit()" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': (loading$ | async)}" id="kt_login_signin_submit" class="btn btn-primary btn-elevate kt-login__btn-primary" style="background-color:black;">{{ 'AUTH.LOGIN.BUTTON' | localize }}</button>
			</div>
			<!--end::Action-->
		</form>
		<!--end::Form-->

		
	</div>
	<!--end::Signin-->
</div>
<!--end::Body-->

